module.exports = {
	"id": "TH",
	"name": "Thailand",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.011322,
			"11": 0.045288,
			"12": 0.01887,
			"13": 0.007548,
			"14": null,
			"15": 0.003774,
			"16": 0.007548,
			"17": 0.003774,
			"18": null,
			"19": null,
			"20": 0.003774,
			"21": 0.015096,
			"22": 0.030192,
			"23": 0.003774,
			"24": null,
			"25": 0.015096,
			"26": 0.01887,
			"27": 0.007548,
			"28": 0.007548,
			"29": 0.007548,
			"30": 0.007548,
			"31": 0.041514,
			"32": 0.015096,
			"33": 0.049062,
			"34": 0.03774,
			"35": 0.022644,
			"36": 0.022644,
			"37": 0.01887,
			"38": 0.041514,
			"39": 0.049062,
			"40": 0.045288,
			"41": 0.015096,
			"42": 0.026418,
			"43": 1.62282,
			"44": 0.045288,
			"45": 0.041514,
			"46": 0.079254,
			"47": 0.07548,
			"48": 0.060384,
			"49": 1.211454,
			"50": 0.105672,
			"51": 0.403818,
			"52": 0.47175,
			"53": 16.839588,
			"54": 4.577862,
			"55": 0.11322,
			"56": 0.030192,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": 0.003774,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.007548,
			"13": null,
			"14": null,
			"15": 0.003774,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.007548,
			"27": null,
			"28": null,
			"29": 0.007548,
			"30": 0.011322,
			"31": 0.007548,
			"32": null,
			"33": 0.011322,
			"34": 0.011322,
			"35": 0.007548,
			"36": 0.003774,
			"37": 0.007548,
			"38": 0.01887,
			"39": 0.015096,
			"40": 0.011322,
			"41": 0.011322,
			"42": 0.015096,
			"43": 0.052836,
			"44": 0.01887,
			"45": 0.030192,
			"46": 0.033966,
			"47": 0.15096,
			"48": 0.158508,
			"49": 1.932288,
			"50": 0.067932,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.007548
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.015096,
			"35": null,
			"36": 0.003774,
			"37": 0.079254,
			"38": 0.011322,
			"39": null,
			"40": 0.13209,
			"41": 0.022644,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.003774
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.003774,
			"6": 0.003774,
			"7": 0.011322,
			"8": 0.045288,
			"9": 0.052836,
			"10": 0.30192,
			"3.1": null,
			"3.2": null,
			"5.1": 0.015096,
			"6.1": 0.011322,
			"7.1": null,
			"9.1": 0.20757
		},
		"ios_saf": {
			"8": 0,
			"10": 10.6937984388,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.288185493859,
			"8.1-8.4": 0.532410488655,
			"9.0-9.2": 0.253993994588,
			"9.3": 3.8750365841
		},
		"android": {
			"3": 0,
			"4": 0.073638372093,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00920479651163,
			"4.1": 0.265624127907,
			"4.2-4.3": 0.664060319767,
			"4.4": 1.52273633721,
			"4.4.3-4.4.4": 1.53588604651
		},
		"ie": {
			"6": null,
			"7": 0.00380667532468,
			"8": 0.258853922078,
			"9": 0.247433896104,
			"10": 0.148460337662,
			"11": 1.10012916883,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0283333027943,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000787036188731
		},
		"edge": {
			"12": 0.030192,
			"13": 0.101898,
			"14": 0.233988
		},
		"ie_mob": {
			"10": 0.0773302816901,
			"11": 0.31484471831
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 4.7559
		},
		"and_uc": {
			"0": 0.65985
		},
		"op_mini": {
			"0": 0.381729661017
		},
		"and_chr": {
			"0": 41.370663
		},
		"and_ff": {
			"0": 0.018675
		}
	},
	"total": 99.26205
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TH.json
 ** module id = 658
 ** module chunks = 0
 **/